import type React from "react";
import {memo} from "react";

import type {Reservation} from "../../models/reservation";
import {Badge, BadgeText} from "../ui/badge";

interface Props {
    reservation: Reservation;
}

const ReservationBadge: React.FC<Props> = ({reservation}) => {
    return (
        <Badge
            action={
                reservation.statusColor === "blue" || reservation.statusColor === "primary"
                    ? "info"
                    : reservation.statusColor
            }
            className="flex-grow-0 flex-shrink-0"
            testID="reservation-badge"
            variant="subtle"
        >
            <BadgeText>{reservation.statusLabel}</BadgeText>
        </Badge>
    );
};

export default memo(ReservationBadge);
